import categorySymbols from "../symbols/categories";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function CategorySymbolsReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case categorySymbols.GET_CATEGORIES:
      return { ...state, loading: true, error: false };
    case categorySymbols.GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case categorySymbols.GET_CATEGORIES_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case categorySymbols.CLEAR_GET_CATEGORIES:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
